export default "__VITE_ASSET__DTc0q8zU__"